import { API_HOST } from '../constants'
import { fetched, logger, returnParser } from '../helpers/util'
import { useAuth } from './auth.hook'
import { v4 as uuidv4 } from 'uuid'

const DO_CDN: any = {
    ORIGIN: 'fronteer-cdn.nyc3.digitaloceanspaces.com',
    CDN: 'cdn.fronteer.app',
}

export function useFile() {
    const { getToken } = useAuth()
    const token = getToken()

    const remove = async ({ filename }) => {
        return await fetched({
            url: `${API_HOST}/files/delete`,
            method: 'DELETE',
            query: { filename },
            token,
        })
    }

    const removeAll = async ({ filenames }) => {
        return await fetched({
            url: `${API_HOST}/files/delete-all`,
            method: 'POST',
            query: { filenames },
            token,
        })
    }

    const getDownloadUrl = async ({ filename, secure }) => {
        return await fetched({
            url: `${API_HOST}/files/download-url`,
            method: 'GET',
            query: { filename, secure },
            token,
        })
    }

    const getUploadUrl = async ({ folder, mime, secure, filename }) => {
        return await fetched({
            url: `${API_HOST}/files/upload-url`,
            method: 'POST',
            body: { folder, mime, secure, filename },
            token,
        })
    }

    const download = async ({ filename }) => {
        try {
            let form = document.createElement('form')
            form.method = 'post'
            form.target = '_blank'
            form.action = `${API_HOST}/files/download?filename=${filename}`
            form.innerHTML = '<input type="hidden" name="token" value="' + token + '">'
            document.body.appendChild(form)
            form.submit()
            document.body.removeChild(form)
        } catch (error) {
            throw error
        }
    }

    const s3upload = async ({ url, file, mime, secure }) => {
        try {
            const response: any = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': mime,
                    //'x-amz-acl': secure ? 'private' : 'public-read',
                },
                body: file,
            })

            return url
                .replace(
                    'https://824a72da502935c269374eec5ccc2827.r2.cloudflarestorage.com/fronteer-public/',
                    'https://cdn.fronteer.app/'
                )
                .split('?')[0]
        } catch (error) {
            logger(error)
            throw error
        }
    }

    const upload = async ({ folder, file, secure }) => {
        try {
            const { name, type, size } = file
            const extension = name.split('.')[name.split('.').length - 1]
            const filename = uuidv4() + '.' + extension
            const mime = type
            const key = folder + '/' + filename

            // Get the signed URL so we can upload
            const { url } = await getUploadUrl({ folder, mime, secure, filename: key })
            logger(`getUploadUrl: ${url}`)

            // Now upload the file with the signed URL
            const uploadedUrl = await s3upload({ url, file, mime, secure })
            logger(`s3upload: ${uploadedUrl}`)

            // return the url
            if (secure) {
                return await getDownloadUrl({ filename: key, secure })
            } else {
                return { url: uploadedUrl }
            }
        } catch (error) {
            logger(error)
            throw error
        }
    }

    const getStorableUrl = (image: string) => {
        return image.split('?')[0]
    }

    return {
        getStorableUrl,
        s3upload,
        remove,
        removeAll,
        download,
        getDownloadUrl,
        getUploadUrl,
        upload,
    }
}
